import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import QuantitySelector from '../components/extra/QuantitySelector';
import { useBlogContext } from '../../fetchdata/BlogContext';
import CreateSlug from '../components/extra/CreateSlug';
import HeaderPage from '../components/HeaderPage';
import NavBar from '../components/NavBar';

const CartPage = () => {

  const { cartItems, removeItemFromCart, updateItemQuantity, getTotalAmount, removePromoCode, getTotalItems, applyPromoCode, promoCodeInfo, mypromoCode, totalAmount } = useBlogContext();

  // console.log('cartItems', cartItems); // Log cartItems to console for debugging


  const [promoCode, setPromoCode] = useState(''); // State to hold the entered promo code

  const handleRemovePromoCode = () => {
    toast.success('Promo code removed')
    removePromoCode();
    // console.log(promoCodeInfo)
  };

  // Function to handle applying promo code
  const handleApplyPromoCode = () => {
    applyPromoCode(promoCode); // Call the applyPromoCode function with the entered promo code
    // console.log('promoCodeInfo', promoCode)
  };

  const handleDecreaseQuantity = (itemId) => {
    updateItemQuantity(itemId, cartItems.find(item => item.id === itemId).quantity - 1);
  };

  const handleIncreaseQuantity = (itemId) => {
    updateItemQuantity(itemId, cartItems.find(item => item.id === itemId).quantity + 1);
  };

  return (
    <>


      <HeaderPage title={'My Cart'} />

      <main className="page-content  mypadding overflow-auto pb-4 px-0" >


        <div className="container overflow-hidden">
          {cartItems && cartItems.length > 0 ? (
            <ul className="dz-list p-b60 px-0">

              {cartItems.map((item) => {
                const myslug = CreateSlug(item.title);

                return (
                  <li className="pull_delete trans" style={{ transform: "translateX(0px)" }}>
                    <div className="dz-cart-list m-b15 bg-transparent border">
                      <div className="dz-media ps-2 py-3">

                        <Link to={`/product/${myslug}/`} className='cursor'> <img src={item.image}
                          className='rounded' style={{
                            width: 100,
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            background: "white"
                          }}
                        /> </Link>



                      </div>
                      <div className="dz-content">
                        <p style={{
                          maxWidth: 200,
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          display: "-webkit-box",
                          whiteSpace: "normal", margin: "0px",
                        }} >{item.title}
                        </p>

                        <ul className="dz-meta ps-0">
                          <li className="dz-price">
                            ₹{item.quantity * item.price}  <del> {item.quantity * item.regularPrice} </del>
                          </li>
                          <li className="dz-review">
                            <i className="feather icon-star-on" />
                            <span type="button" onClick={() => removeItemFromCart(item.id)} className='text-danger' >Remove</span>
                          </li>
                        </ul>
                        <div className=" d-flex align-items-center">
                          <div className="dz-stepper style-2">
                            <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                              <span className="input-group-btn input-group-prepend">
                                <button
                                  className="btn btn-primary bootstrap-touchspin-down"
                                  type="button"
                                  disabled={promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0}
                                  onClick={() => handleDecreaseQuantity(item.id)}
                                >
                                  -
                                </button>
                              </span>
                              <input
                                readOnly=""
                                className="stepper form-control bg-transparent border-0"
                                type="text"
                                value={item.quantity}
                                name="demo3"
                              />
                              <span className="input-group-btn input-group-append">
                                <button
                                  className="btn btn-primary bootstrap-touchspin-up"
                                  type="button"
                                  disabled={promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0}
                                  onClick={() => handleIncreaseQuantity(item.id)}
                                >
                                  +
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <i className="pd_btn" />

                  </li>
                )



              })}
            </ul>


          ) : <div className="text-center mt-5 mb-4">

            <img src="/assets/img/product-not-found.png" alt='no cart' style={{ maxWidth: 200 }} />
            <p className="h3" style={{ fontWeight: 300 }} > No items in the cart </p>
            <Link className="btn btn-primary btn-shadow d-block w-50 mt-4 mx-auto" to="/">Shop Now</Link>

          </div>
          }
          <div className="col-lg-12">
            {cartItems && cartItems.length > 0 && (
              <>
                <div className="card border">

                  <div className="card-body">

                    {promoCodeInfo && promoCodeInfo.type && promoCodeInfo.discount > 0 ? (<>
                      <div className="d-flex align-items-center justify-content-between">
                        <p>Sub Total </p>
                        <p>₹{cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}</p>
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <p >Discount </p>
                        <p>{totalAmount - (cartItems.reduce((total, item) => total + item.quantity * item.price, 0))}</p>

                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <p >Discount </p>
                        <p>{totalAmount - (cartItems.reduce((total, item) => total + item.quantity * item.price, 0))}</p>

                      </div>


                      <div className="d-flex align-items-center justify-content-between">
                        <h5> Total </h5>
                        <h5>₹{totalAmount}</h5>
                      </div>

                      <div className="d-flex align-items-center justify-content-between mypromobox mb-2">
                        <div className="d-flex align-items-center justify-content-between gap-2" >
                          <i className="ri-checkbox-circle-line text-success h4"></i>

                          <p className='m-0'> <b> {mypromoCode} </b>  applied <br />
                            {promoCodeInfo.type === "percentage" ? (<>
                              {promoCodeInfo.discount * 100}% OFF
                            </>) : (<>
                              ₹{promoCodeInfo.discount} OFF
                            </>)}  </p>

                        </div>

                        <button type="button" className="btn btn-danger p-2" onClick={handleRemovePromoCode}>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            height={16}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                            <line x1={10} y1={11} x2={10} y2={17} />
                            <line x1={14} y1={11} x2={14} y2={17} />
                          </svg>{" "}
                        </button>


                      </div>

                    </>) : (<>
                      <div className="d-flex align-items-center justify-content-between">
                        <h5> Total </h5>
                        <h5>  {cartItems.length > 0 && (
                          <>  ₹ {cartItems.reduce((total, item) => total + item.quantity * item.price, 0)}
                          </>
                        )} </h5>

                      </div>

                      <hr className="mb-4" />
                      <div className="col-auto mb-3">
                        <div className="input-group">
                          <input id="promoCode1" type="text" className="form-control" onChange={(e) => setPromoCode(e.target.value)} placeholder="Promo code" value={promoCode} />
                          <button className="btn btn-primary" onClick={handleApplyPromoCode} type="button" id="button-promo">Apply</button>
                        </div>
                      </div>

                    </>
                    )}





                    <Link className="btn btn-primary btn-shadow d-block w-100" to="/checkout">Checkout</Link>
                  </div>

                </div>
              </>
            )}

          </div>

        </div>


        <NavBar />

      </main>
    </>
  );
};


export default CartPage
